import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Authentication, Common, FeatureFlag } from '@hsi/ui-core';
import { environment } from '../../environments/environment';
import { AppUtilityService } from './app-utility.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppStoreService {
  tennant = localStorage.getItem('company') || 'ashi';

  tokenProvider = new Authentication.Infrastructure.WebStorageTokenProvider('authToken');
  microserviceHttpClient = new Common.Infrastructure.MicroserviceClient(this.tokenProvider);

  authClient = new Authentication.Infrastructure.HsiResourceOwnerRef30Client(
    this.microserviceHttpClient,
    environment.authentication.server,
    environment.authentication.clients.hsiResourceOwnerRef30.secret,
    environment.authentication.clients.hsiResourceOwnerRef30.scope
  );

  administrationRepository = new Common.Infrastructure.AdministrationMicroservice(
    this.microserviceHttpClient,
    environment.microservice.administration
  );

  authenticationService = new Authentication.Core.AuthenticationService(
    this.authClient,
    this.administrationRepository,
    this.tokenProvider,
    () => {
      // Angular router navigation
      this.router.navigate(['/', this.tennant, 'login']);
      this.appUtility.displayMessage({
        text: 'Your session has expired.  Please reauthenticate to continue.',
        actionText: "OK",
        duration: -1
      });
    }
  );

  featureFlagProvider = new FeatureFlag.Core.FeatureFlagProvider(
    new FeatureFlag.Infrastructure.FeatureFlagMicroservice(
      this.microserviceHttpClient,
      environment.microservice.featureFlagging
    )
  );

  installable$ = new BehaviorSubject<boolean>(false);

  constructor(private router: Router, private appUtility: AppUtilityService) {}

  setInstallable(value: boolean) {
    this.installable$.next(value);
  }
}